<template>
  <div class="attachment-selector-compact d-flex flex-column align-items-end">
    <button
      class="btn btn-sm btn-outline-primary"
      @click="openModal"
    >
      {{ $t('daily_summary.add_attachment') }}
    </button>
    <div v-if="selectedAttachmentsList.length > 0" class="selected-attachments mt-1">
      <div
        v-for="attachment in selectedAttachmentsList"
        :key="attachment.id"
        class="selected-attachment-item"
      >
        <span
          @click="downloadAttachment(attachment)"
        >
            {{ attachment.file_original_name || attachment.filename || attachment.name || 'Unnamed file' }}
        </span>
        <button
          class="btn btn-sm btn-link text-danger p-0 ms-2"
          @click="removeAttachment(attachment.id)"
        >
          ×
        </button>
      </div>
    </div>

    <div v-if="showModal" class="modal-backdrop" @click="closeModal"></div>
    <div v-if="showModal" class="attachment-modal">
      <div class="modal-header">
        <h5>{{ $t('daily_summary.select_attachments') }}</h5>
        <button class="btn-close" @click="closeModal"></button>
      </div>
      <div class="modal-body">
        <p class="info-text text-muted mb-3">{{ $t('daily_summary.select_attachments_info') }}</p>
        <div v-if="contractAttachments.length === 0" class="text-muted">
          {{ $t('daily_summary.no_contract_attachments') }}
        </div>
        <div v-else>
          <div
            v-for="attachment in contractAttachments"
            :key="attachment.id"
            class="form-check mb-2"
          >
            <input
              :id="`attachment-${attachment.id}`"
              v-model="tempSelectedAttachments"
              class="form-check-input"
              type="checkbox"
              :value="attachment.id"
            >
            <label
              class="form-check-label"
              :for="`attachment-${attachment.id}`"
            >
              {{ attachment.file_original_name || attachment.filename || attachment.name || $t('daily_summary.no_filename') }}
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary me-2" @click="closeModal">
          {{ $t('common.cancel') }}
        </button>
        <button class="btn btn-success" @click="confirmSelection">
          {{ $t('common.ok') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceAttachmentSelector',
  props: {
    contractAttachments: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    contractId: {
      type: Number,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      showModal: false,
      tempSelectedAttachments: []
    }
  },
  computed: {
    selectedAttachments: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    selectedAttachmentsList() {
      return this.contractAttachments.filter(a => this.selectedAttachments.includes(a.id))
    }
  },
  methods: {
    removeAttachment(id) {
      this.selectedAttachments = this.selectedAttachments.filter(attachmentId => attachmentId !== id)
    },
    openModal() {
      this.tempSelectedAttachments = [...this.selectedAttachments]
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    confirmSelection() {
      this.selectedAttachments = [...this.tempSelectedAttachments]
      this.showModal = false
    },
    downloadAttachment(attachment) {
      this.$emit('downloadAttachment', attachment)
    }
  }
}
</script>

<style scoped>
.attachment-selector-compact {
  position: relative;
}
.selected-attachments {
  font-size: 0.875rem;
}
.selected-attachment-item {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  margin-bottom: 0.25rem;
}
.selected-attachment-item span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.attachment-link {
  cursor: pointer;
  color: #0d6efd;
  text-decoration: underline;
}
.attachment-link:hover {
  color: #0a58ca;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}
.attachment-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  z-index: 1050;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 0.5rem;
}
.modal-header h5 {
  margin: 0;
  font-size: 1.5rem;
}
.info-text {
  font-size: 0.875rem;
}
.modal-body {
  padding: 0.5rem 1.5rem 1.5rem;
  overflow-y: auto;
  flex: 1;
}
.modal-footer {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
}
</style>
